import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsFormFieldSearchComponent } from './seds-form-field-search.component';
import { SedsFormFieldCoreModule } from '../seds-form-field-core/seds-form-field-core.module';

@NgModule({
  declarations: [SedsFormFieldSearchComponent],
  imports: [CommonModule, SedsFormFieldCoreModule],
  exports: [SedsFormFieldSearchComponent],
})
export class SedsFormFieldSearchModule {}
